const addProfileToList = async (listId, email) => {
	try {
		const response = await fetch("/.netlify/functions/add-profile-to-list", {
			method: "POST",
			body: JSON.stringify({ listId, email }),
		});
		const data = await response.json();
		return data;
	} catch (error) {
		console.error({ error });
		return { error: "Failed to add profile to list" };
	}
};

export default addProfileToList;